// Shared "Free tools" nav dropdown behavior. Self-contained — looks for any
// element matching .tools-nav-dd and wires up click-to-open + outside-click-to-close.
(function () {
  function init() {
    var dds = document.querySelectorAll('.tools-nav-dd');
    if (!dds.length) return;
    dds.forEach(function (dd) {
      var btn = dd.querySelector('.tools-nav-dd-btn');
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = dd.classList.toggle('open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    document.addEventListener('click', function (e) {
      dds.forEach(function (dd) {
        if (!dd.contains(e.target)) {
          dd.classList.remove('open');
          var btn = dd.querySelector('.tools-nav-dd-btn');
          if (btn) btn.setAttribute('aria-expanded', 'false');
        }
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        dds.forEach(function (dd) { dd.classList.remove('open'); });
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
